module.exports = __webpack_public_path__ + "static/media/shade.dbb8d8b4.jpg";